export default function PetSection() {
  const features = [
    'ペットボディスキャンによる健康管理',
    'アニマルセラピー・訪問活動',
    '動物福祉の啓発とコミュニティづくり',
  ];

  return (
    <section id="pet" className="py-36 bg-gradient-to-br from-[#F0F8FF] via-[#FFFFFF] to-[#F0F8FF]">
      <div className="max-w-[1300px] mx-auto px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* 左側：ビジュアル */}
          <div className="relative">
            <div className="relative">
              {/* 背面画像 */}
              <div className="rounded-[32px] overflow-hidden shadow-xl">
                <div className="aspect-[4/5] w-full h-full">
                  <img
                    src="https://public.readdy.ai/ai/img_res/46d0cb7b4df036d02711c87c2176e113.jpg"
                    alt="人とペットの絆"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* 前面画像 */}
              <div className="absolute -bottom-8 -right-8 w-64 h-64 rounded-[24px] overflow-hidden shadow-2xl border-8 border-white">
                <img
                  src="https://readdy.ai/api/search-image?query=Joyful%20moment%20of%20a%20person%20playing%20with%20their%20cute%20cat%20in%20a%20bright%20home%20environment%2C%20featuring%20playful%20interaction%20and%20happiness%2C%20clean%20white%20and%20soft%20pastel%20background%2C%20professional%20pet%20photography%20with%20natural%20lighting%20and%20warm%20atmosphere&width=500&height=500&seq=pet-wellbeing-002&orientation=squarish"
                  alt="ペットとの楽しい時間"
                  className="w-full h-full object-cover object-center"
                />
              </div>

              {/* 装飾要素 */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 opacity-20">
                <div className="w-full h-full rounded-full bg-gradient-to-br from-[#4A90E2] to-[#50C9C3] blur-xl"></div>
              </div>
            </div>
          </div>

          {/* 右側：コンテンツ */}
          <div className="lg:pl-10">
            <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-5">
              PET × WELL-BEING
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C] leading-snug mb-8">
              人とペットが<br />
              ともにしあわせに<br />
              暮らすために
            </h2>
            <p className="text-lg leading-relaxed text-[#3A4A5A] mb-10">
              ペットは、家族であり、心の支えでもあります。<br />
              未来ウェルビーイング協会では、ペットとの共生を通じて、<br />
              心身の健康・癒し・社会的つながりを育む取り組みを行っています。
            </p>

            {/* 特徴リスト */}
            <div className="space-y-5 mb-12">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent"></i>
                  </div>
                  <span className="text-base font-semibold text-[#1A2B3C]">
                    {feature}
                  </span>
                </div>
              ))}
            </div>

            {/* CTAボタン */}
            <button className="h-14 px-9 bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] text-white text-base font-semibold rounded-full hover:shadow-xl transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer">
              ペットプログラムを見る
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
